<template>
  <div class="subject-list">
    <div class="flex space-between">
      <h4>{{ $t('vue2.createklass.subjects_for') }}
        {{ activeKlassStep }}<span v-if="locale !== 'en'">.</span><span v-else>{{ classesNumberized }}</span>
        {{ $t('vue2.createklass.grade') }}
      </h4>
    </div>
    <div v-if="isLoading">
      <Spinner color="blue"></Spinner>
    </div>
    <ul v-else>
      <li v-for="subject in activeSubjects"
          class="subject-list__subject"
          :style="{backgroundColor: subject.color}">
        <div>{{ subject.subject }}</div>
        <div>{{ subject.hours | removeDecimal }}{{ $t('vue2.createklass.hoursPrYear') }}</div>
      </li>
    </ul>
  </div>
</template>


<script>
import docendo from '../../../docendo'
import Spinner from '../../common/Spinner'
import moment from 'moment' // eslint-disable-line no-unused-vars

export default {
  components: {Spinner},
  props: {
    arrowPosition: {},
    activeKlassStep: {
      default: 1
    },
    klassStepIsSelected: {
      default: false
    },
    country: {
      default: 'dk'
    }
  },
  filters: {
    removeDecimal (number) {
      return Math.round(number * 1)
    }
  },
  computed: {
    activeSubjects () {
      return this.subjects.filter(obj => {
        return obj.step === this.activeKlassStep.toString()
      })
    },
    locale () {
      return moment.locale()
    },
    classesNumberized () {
      switch (this.activeKlassStep) {
        case 1:
          return 'st'
        case 2:
          return 'nd'
        case 3:
          return 'rd'
        default:
          return 'th'
      }
    }
  },
  data () {
    return {
      isLoading: true,
      subjects: []
    }
  },
  mounted () {
    docendo.subjectNormsSchool(window.SCHOOL.id, data => {
      this.subjects = data
      this.isLoading = false
    })
  }
}
</script>

<style scoped>
.subject-list {
  position: relative;
  pointer-events: none;
  z-index: 10;
  padding: 5px;
  cursor: pointer;
  background: #f6f7f8;
  border: 1px solid #d8d8d8;
  margin: 0 20px;
}

.subject-list > div {
  border-bottom: 1px solid #d8d8d8;
  margin: 0 -5px 5px -5px;
  padding: 0 10px;
}

.subject-list__subject {
  width: 100%;
  font-size: 11px;
  margin-bottom: 5px;
  border-radius: 4px;
  color: white;
  display: flex;
  justify-content: space-between;
  padding: 2px 5px;
}

</style>



// WEBPACK FOOTER //
// CreateKlassesSubjectList.vue?bd3cd218